import { Wrapper } from '@ahmdigital/ui';
import styled from 'styled-components';

import LifeInsuranceChangeAlert from '../../../components/life-insurance-alert';

const StyledWrapper = styled(Wrapper)`
  padding-top: 2rem;
  margin-bottom: -3rem;
`;

const Alert = () => (
  <StyledWrapper>
    <LifeInsuranceChangeAlert />
  </StyledWrapper>
);

export default Alert;
